import { Component } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-legal-notice",
  standalone: true,
  templateUrl: "./legal-notice.component.html",
  imports: [TranslateModule],
})
export class LegalNoticeComponent {}
